import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Headers, Http, Response } from '@angular/http';
import { AuthenticationService } from 'app/core/index';
import { map, take, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BonusService {
  bonusCount: number = 0;
  bonusCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(this.bonusCount);
  onBonusCountChanged: Observable<number> = this.bonusCountSubject.asObservable();
  constructor(private http: Http, private auth: AuthenticationService) {}

  public getBonuses(status?: string) {
    let filter = '?_sort=createdAt&_order=DESC';
    if (status) {
      filter += '&status=' + status;
    }
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .get('/api/bonuses' + filter, {
        headers: headers,
      })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public getInactiveBonuses(accessToken: string) {
    const headers: Headers = new Headers();
    headers.append('Authorization', accessToken);

    return this.http
      .get('/api/bonuses/inactive', {
        headers: headers,
      })
      .pipe(
        take(1),
        map(data => data.json()),
        tap(data => {
          this.bonusCount = data;
          this.bonusCountSubject.next(this.bonusCount);
        })
      );
  }

  public activateBonus(id: any) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .post(`/api/bonuses/${id}/activate`, {}, { headers: headers })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public forfeitBonus(id: any) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .post(`/api/bonuses/${id}/forfeit`, {}, { headers: headers })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public getDepositBonuses() {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.get(`/api/bonuses/deposit-bonuses`, { headers: headers }).pipe(
      map((response: Response) => {
        return response.json();
      })
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/bonus.service.ts